import i18n from "../i18n";
import { callAutomationsApi } from "./automations-api";

const SETTINGS = "automation-sending-settings";
const DOMAIN = "automation-sending-domain";
const FIELDS = ["fromName", "fromEmail", "replyTo", "postalAddress"];

const t = (key, options) =>
  i18n.t(`coaching-portal:emailSending.${key}`, options);

const call = (api, path, method, payload) =>
  callAutomationsApi(api, path, method, payload, t("errors.generic"));

// Runs one of the Setup email actions: success shows the message, a failure shows the API's error,
// and either way the coach lands back on the open modal
const handler = (run, messageKey) => async (ctx) => {
  const { res, flash } = ctx;
  try {
    await run(ctx);
    flash("success", t(messageKey));
  } catch (error) {
    flash("error", error.message);
  }
  res.backDontScroll();
};

const pickFields = (body) =>
  Object.fromEntries(FIELDS.map((field) => [field, body[field] ?? ""]));

const save = async ({ api, req }) => {
  const fields = pickFields(req.body);
  const current = await call(api, SETTINGS, "GET");
  // The domain is the one of the From address: the first save sets it up
  if (!current.domain && fields.fromEmail) {
    await call(api, DOMAIN, "POST", { domain: fields.fromEmail });
  }
  await call(api, SETTINGS, "PUT", fields);
};

const SendingSettings = (app) => {
  app
    .post("/automation-sending/save", handler(save, "saved"))
    .post(
      "/automation-sending/check",
      handler(({ api }) => call(api, `${DOMAIN}/check`, "POST", {}), "checked")
    )
    .post(
      "/automation-sending/instructions",
      handler(
        ({ api, req }) =>
          call(api, `${DOMAIN}/instructions`, "POST", {
            email: req.body.instructionsEmail ?? "",
          }),
        "instructionsSent"
      )
    )
    .post(
      "/automation-sending/change-domain",
      handler(({ api }) => call(api, DOMAIN, "DELETE"), "domainRemoved")
    );
};

export default SendingSettings;
